import type { ComponentProps, PropsWithChildren } from 'react'

import { Icon } from '@/components/icon'
import { cn } from '@/infra'

interface IHeaderCompactoProps extends PropsWithChildren {
  showStickyHeader: boolean
}

interface IHeaderCompactoDetalhesItemProps extends ComponentProps<'div'> {
  icon: ComponentProps<typeof Icon>['name']
  label: string
  value: string
}

export const HeaderCompacto = ({ showStickyHeader, children }: IHeaderCompactoProps) => {
  return (
    <div
      className={cn(
        `bg-foreground fixed top-0 right-0 left-0 z-40 shadow-xl transition-all duration-[250ms] ${
          showStickyHeader
            ? 'visible translate-y-0 opacity-100'
            : 'pointer-events-none invisible -translate-y-full opacity-0'
        } hidden sm:block md:left-[16rem] group-has-data-[collapsible=icon]/sidebar-wrapper:md:left-[3rem]`,
      )}
    >
      <div className="font-nunito flex flex-col items-center gap-4 px-8 py-4 text-sm">{children}</div>
    </div>
  )
}

export const HeaderCompactoDetalhes = ({ children, className, ...props }: ComponentProps<'div'>) => {
  return (
    <div className={cn('flex items-center space-x-12', className)} {...props}>
      {children}
    </div>
  )
}

export const HeaderCompactoDetalhesItem = ({
  icon,
  label,
  value,
  className,
  ...props
}: IHeaderCompactoDetalhesItemProps) => {
  return (
    <div className={cn('flex items-center space-x-1 text-sm', className)} {...props}>
      <Icon name={icon} />
      <span className="text-muted-foreground">{label}:</span>
      <span className="font-medium">{value}</span>
    </div>
  )
}
